export default {
  // Hero Section
  'hero.badge': 'Gateway to Baltics & Northern Europe Market',
  'hero.title.line1': 'Export Asian Goods',
  'hero.title.highlight1': '',
  'hero.title.line2': 'To',
  'hero.title.highlight2': 'Baltics & Northern Europe',
  'hero.title.line3': 'Market',
  'hero.description': 'The Daeg International Trade - Trusted partner helping Asian businesses access the Baltics and Northern Europe market with over 5 million people through Latvia. Leverage logistics advantages and low costs in the Northern Europe segment.',
  'hero.stats.population': 'Baltics & Northern Europe Population',
  'hero.stats.experience': 'Years of Experience',
  'hero.stats.locations': 'Distribution Centers',
  'hero.stats.support': 'Comprehensive Support',
  'hero.cta.contact': 'Contact for Partnership',
  'hero.cta.learn': 'Learn More',

  // Opportunity Section
  'opportunity.title': 'Why Export to Baltics & Northern Europe via Latvia?',
  'opportunity.description': 'Latvia is the ideal gateway for Asian businesses to access the Baltics and Northern Europe market with a population of over 30 million people.',
  'opportunity.item1.title': 'Strategic Location',
  'opportunity.item1.desc': 'Latvia is located at the heart of the Baltics, with convenient access to Estonia, Lithuania, and Northern Europe markets.',
  'opportunity.item2.title': 'Low Logistics Costs',
  'opportunity.item2.desc': 'Competitive logistics costs compared to other Northern European countries, helping optimize business profits.',
  'opportunity.item3.title': 'Growing Market',
  'opportunity.item3.desc': 'The Baltics and Northern Europe market has a population of over 30 million with high purchasing power and increasing demand for Asian products.',
  'opportunity.item4.title': 'EU Member',
  'opportunity.item4.desc': 'Latvia is an EU member, making it easy to distribute goods throughout the European market without customs barriers.',

  'opportunity.latvia.title': "Latvia's Strengths",
  'opportunity.latvia.desc.short': 'Port of Riga — one of the largest ports in the Baltics. Operating costs <strong>30–40% lower</strong> than Northern Europe, helping businesses <strong>optimize costs</strong> while accessing a market of over 30 million people.',
  'opportunity.latvia.desc.full': 'Latvia has a <strong>modern logistics system</strong> with the Port of Riga — one of the largest ports in the Baltics region. Rental, labor and operating costs are <strong>30–40% lower</strong> than Northern European countries such as Sweden, Norway, and Finland. This is a major competitive advantage for businesses looking to <strong>optimize costs</strong> while still accessing the wealthy Northern European market of over 30 million people.',

  // Services Section
  'services.title': 'Comprehensive Export Services',
  'services.description': 'We provide full-service solutions from import, distribution to logistics and legal support.',
  'services.service1.title': 'Import & Customs Clearance',
  'services.service1.desc': 'Professional customs clearance services, ensuring goods are imported quickly and legally.',
  'services.service1.feature1': 'Complete customs procedures',
  'services.service1.feature2': 'VAT and tax consulting',
  'services.service1.feature3': 'Product certification support',
  'services.service1.feature4': 'Fast processing time',
  'services.service2.title': 'Distribution via Asian Alley',
  'services.service2.desc': 'Distribute products through our Asian Alley and Cho Hem Kiosk system in Riga.',
  'services.service2.feature1': '2 distribution centers',
  'services.service2.feature2': 'Prime locations',
  'services.service2.feature3': 'Diverse customer base',
  'services.service2.feature4': 'Professional management',
  'services.service3.title': 'Logistics & Warehousing',
  'services.service3.desc': 'Modern warehouse system and professional logistics services.',
  'services.service3.feature1': 'Safe storage',
  'services.service3.feature2': 'Inventory management',
  'services.service3.feature3': 'Fast delivery',
  'services.service3.feature4': 'Competitive costs',
  'services.service4.title': 'Legal & Tax Consulting',
  'services.service4.desc': 'Legal and tax consulting services to ensure compliance with Latvian and EU regulations.',
  'services.service4.feature1': 'Business registration',
  'services.service4.feature2': 'Tax consulting',
  'services.service4.feature3': 'Contract support',
  'services.service4.feature4': 'Legal compliance',
  'services.service5.title': 'Market Research',
  'services.service5.desc': 'Market research and analysis services to help you understand customer needs.',
  'services.service5.feature1': 'Market analysis',
  'services.service5.feature2': 'Competitor research',
  'services.service5.feature3': 'Pricing strategy',
  'services.service5.feature4': 'Trend forecasting',
  'services.service6.title': '24/7 Support',
  'services.service6.desc': 'Dedicated support team ready to assist you anytime.',
  'services.service6.feature1': 'Multilingual support',
  'services.service6.feature2': 'Quick response',
  'services.service6.feature3': 'Professional consulting',
  'services.service6.feature4': 'Long-term partnership',

  // Asian Alley Section
  'asianAlley.title': 'Asian Alley - Asian Product Distribution System',
  'asianAlley.description': 'Asian Alley is our Asian product distribution system with 2 locations in Riga, serving thousands of customers monthly.',
  'asianAlley.badge': 'Exclusive Distribution Channel',
  'asianAlley.subtitle': 'Leading Asian Supermarket in Riga',
  'asianAlley.description2': 'Not just a retail point, Asian Alley is also a <strong>living showroom</strong> that helps partners verify real market feedback, thereby adjusting products to suit the taste and needs of European consumers.',
  'asianAlley.callout.title': 'Exclusive Advantage:',
  'asianAlley.callout.desc': 'The Daeg partners are prioritized for display at Asian Alley — the only distribution channel specializing in Asian goods in Latvia.',
  'asianAlley.stats.locations': 'Locations',
  'asianAlley.stats.revenue': 'Annual Revenue',
  'asianAlley.stats.customers': 'Monthly Customers',
  'asianAlley.stats.products': 'Product Categories',
  'asianAlley.stats.locationsSub': 'In central Riga',
  'asianAlley.stats.customersSub': 'Real consumers',
  'asianAlley.stats.productsSub': 'Diverse categories',
  'asianAlley.stats.revenueSub': 'Stable growth',
  'asianAlley.cta': 'Learn More About Asian Alley',

  // Process Section
  'process.title': 'Export Process',
  'process.description': 'Simple and transparent process, helping you easily export goods to the Baltics and Northern Europe market.',
  'process.step1.title': 'Contact & Consultation',
  'process.step1.desc': 'Contact us for detailed consultation on products and export process.',
  'process.step2.title': 'Product Evaluation',
  'process.step2.desc': 'We evaluate products and provide market analysis and pricing strategy.',
  'process.step3.title': 'Contract Signing',
  'process.step3.desc': 'Sign partnership contract and agree on terms.',
  'process.step4.title': 'Import & Customs',
  'process.step4.desc': 'We handle import procedures and customs clearance.',
  'process.step5.title': 'Distribution',
  'process.step5.desc': 'Products are distributed through Asian Alley or other channels.',
  'process.step6.title': 'Payment & Reporting',
  'process.step6.desc': 'Transparent payment and detailed monthly reporting.',

  // Why Us Section
  'whyUs.title': 'Why Choose The Daeg International Trade?',
  'whyUs.description': 'We are a trusted partner with over 5 years of experience in the Asian goods export field.',
  'whyUs.reason1.title': 'Extensive Experience',
  'whyUs.reason1.desc': 'Over 5 years of experience in Asian goods export and distribution in the Baltics and Northern Europe market.',
  'whyUs.reason2.title': 'Existing Distribution System',
  'whyUs.reason2.desc': 'Asian Alley distribution system with 2 locations in Riga and Liepaja, serving thousands of customers monthly.',
  'whyUs.reason3.title': 'Professional Team',
  'whyUs.reason3.desc': 'Experienced team with deep knowledge of the Baltics and Northern Europe market.',
  'whyUs.reason4.title': 'Competitive Costs',
  'whyUs.reason4.desc': 'Competitive logistics and distribution costs, helping optimize business profits.',
  'whyUs.reason5.title': 'Comprehensive Support',
  'whyUs.reason5.desc': 'Full support from import, distribution to legal and tax consulting.',
  'whyUs.reason6.title': 'Long-term Partnership',
  'whyUs.reason6.desc': 'We are committed to long-term partnership and sustainable development with partners.',

  // Contact Section
  'contact.title': 'Ready to Export to Baltics & Northern Europe?',
  'contact.description': 'Contact us today for detailed consultation on export services.',
  'contact.form.name': 'Full Name',
  'contact.form.namePlaceholder': 'Enter your full name',
  'contact.form.company': 'Company Name',
  'contact.form.companyPlaceholder': 'Enter your company name',
  'contact.form.phone': 'Phone Number',
  'contact.form.phonePlaceholder': 'Enter your phone number',
  'contact.form.email': 'Email',
  'contact.form.emailPlaceholder': 'Enter your email',
  'contact.form.product': 'Product Category',
  'contact.form.productPlaceholder': 'Enter product category you want to export',
  'contact.form.message': 'Message',
  'contact.form.messagePlaceholder': 'Tell us about your export needs...',
  'contact.form.submit': 'Send Request',
  'contact.form.submitting': 'Sending...',
  'contact.success': 'Request sent successfully! We will contact you soon.',
  'contact.error': 'An error occurred. Please try again.',

  // Export Services Section
  'services.sectionTitle': 'Complete Solutions',
  'services.sectionTitleHighlight': 'For Export Partners',

  // Export Process Section
  'process.sectionTitle': '6 Simple Steps to',
  'process.sectionTitleHighlight': 'Export to EU',
  'process.stepLabel': 'Step',
  'process.stepOf': '/',
  'process.prevBtn': 'Previous',
  'process.nextBtn': 'Next',
  'process.step1.duration': '1-3 days',
  'process.step2.duration': '3-5 days',
  'process.step3.duration': '7-14 days',
  'process.step4.duration': '15-30 days',
  'process.step5.duration': 'Ongoing',
  'process.step6.duration': 'From month 3+',
  'process.timelineNote': 'Total time from contract signing to goods in warehouse:',
  'process.timelineValue': 'only 30-45 days',

  // Export Contact Section
  'contact.badge': 'Partnership Inquiry',
  'contact.formTitle': 'Register Export Partnership',
  'contact.formSubtitle': 'Free consultation — No commitment',
  'contact.hotlineLabel': 'Partnership Hotline',
  'contact.hotlineSub': 'Whatsapp / Call / Viber',
  'contact.emailSub': 'Response within 24h',
  'contact.officeLabel': 'Office',
  'contact.officeSub': 'Riga, Latvia, EU',
  'contact.commitmentTitle': 'Our Commitment',
  'contact.commitmentQuote': 'We are not just importers — we are strategic partners, accompanying Asian businesses in building a sustainable brand in the 450-million-people European market.',
  'contact.companyEstablished': 'Riga, Latvia — Est. 2019',
  'contact.form.country': 'Country',
  'contact.form.countryPlaceholder': 'Select country',
  'contact.form.volume': 'Expected Export Volume',
  'contact.form.volumePlaceholder': 'Select volume',
  'contact.form.privacyNote': 'By submitting this form, you agree to be contacted for consultation. Your information is kept strictly confidential.',
  'contact.countries.vietnam': 'Vietnam',
  'contact.countries.china': 'China',
  'contact.countries.thailand': 'Thailand',
  'contact.countries.japan': 'Japan',
  'contact.countries.korea': 'South Korea',
  'contact.countries.indonesia': 'Indonesia',
  'contact.countries.malaysia': 'Malaysia',
  'contact.countries.philippines': 'Philippines',
  'contact.countries.india': 'India',
  'contact.countries.other': 'Other',
  'contact.categories.food': 'Food & Beverages',
  'contact.categories.spices': 'Spices & Sauces',
  'contact.categories.noodles': 'Noodles & Dried Pasta',
  'contact.categories.snacks': 'Snacks & Confectionery',
  'contact.categories.consumer': 'Consumer Goods',
  'contact.categories.cosmetics': 'Cosmetics & Personal Care',
  'contact.categories.household': 'Household Goods',
  'contact.categories.other': 'Other',
  'contact.volumes.under1': 'Under 1 container/month',
  'contact.volumes.1to3': '1-3 containers/month',
  'contact.volumes.3to5': '3-5 containers/month',
  'contact.volumes.over5': 'Over 5 containers/month',
};